import { cloneElement, CSSProperties, MutableRefObject } from 'react';

export interface IUseElevateElementProps {
  children: JSX.Element;
  doElevate?: boolean;
  sourceRef: MutableRefObject<HTMLElement | null>;
}

/**
 * Copy an element so it can be displayed in a the same position in a different stacking context,
 * e.g. a callout source icon button that needs to appear between the callout overlay and the callout body,
 * directly above the original source, without interrupting the original element's layout flow.
 *
 * @param props
 * @returns JSX for cloned element positioned above the original
 */

export function useElevateElement({ children, doElevate, sourceRef }: IUseElevateElementProps) {
  const rect = doElevate ? sourceRef.current?.getBoundingClientRect() : undefined;
  const style: CSSProperties =
    doElevate && rect
      ? {
          position: 'absolute',
          top: rect.y,
          left: rect.x,
          // inline width/height in case original styles used percents:
          width: rect.width,
          height: rect.height,
        }
      : {};

  // clone, but overwrite original HTML element forwardRef, so clone doesn't hijack it.
  return doElevate ? cloneElement(children, { ref: null, style }) : undefined;
}
